import { ClientPortalAreas } from "../../../interfaces/ClientPortal";

export type PortalTab = "overview" | "schedule" | "projects" | "hours" | "billings" | "tickets" | "fila" | "filas" | "equipe" | "organograma";

/** Aba -> área exigida. `overview` não tem área: o backend filtra os campos por dentro. */
const AREA_DA_ABA: Record<PortalTab, keyof ClientPortalAreas | null> = {
  overview: null,
  schedule: "podeVerProjetos",
  projects: "podeVerProjetos",
  hours: "podeVerHoras",
  billings: "podeVerFinanceiro",
  tickets: "podeVerChamados",
  // As duas abas da fila da organização também passam pela porta da área Chamados (`portal.tickets`).
  fila: "podeVerChamados",
  filas: "podeVerChamados",
  // Equipe e organograma do cliente têm porta própria (`cliente.equipe.gerir` / `portal.projects` / `clientportal.view`).
  equipe: null,
  organograma: null,
};

export const temAlgumaArea = (areas: ClientPortalAreas): boolean =>
  Object.values(areas).some(Boolean);

export const abaLiberada = (aba: PortalTab, areas: ClientPortalAreas): boolean => {
  const area = AREA_DA_ABA[aba];
  return area === null || areas[area];
};

/**
 * Mensagem do 403 de área do portal (`{ area, message }`). Devolve null quando o erro não é esse
 * caso, para o chamador manter o próprio tratamento. Esconder a aba sozinho seria fachada: a
 * mensagem do servidor é o que diz à pessoa o que fazer.
 */
export function mensagemDeAreaNegada(error: unknown): string | null {
  const resp = (error as { response?: { status?: number; data?: unknown } } | null)?.response;
  if (resp?.status !== 403 || !resp.data || typeof resp.data !== "object") return null;
  const message = (resp.data as { message?: unknown }).message;
  return typeof message === "string" && message.trim() ? message : null;
}
